import {
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { EnvToken } from '@app/core/env.tokens';
import { MatDialog } from '@angular/material/dialog';
import { VideoDialogComponent } from '@dialogs/videoDialog/videoDialog';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { GenericButtonWithArrow } from '@components/shared/genericButtonWithArrow/genericButtonWithArrow';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ExternalService } from '@app/services/http/external.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  imports: [
    CommonModule,
    NgOptimizedImage,
    TranslatePipe,
    GenericButtonWithArrow,
    MatIconModule,
  ],
  providers: [TranslatePipe, ExternalService],
  selector: 'app-how-it-works',
  templateUrl: './howItWorks.component.html',
  styleUrls: ['./howItWorks.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.Emulated, // or ViewEncapsulation.ShadowDom
})
export class HowItWorksComponent implements OnInit {
  protected readonly env = inject(EnvToken);

  @Input() isVerticalPage: boolean = false;
  @Input() textIsWhite: boolean = false;
  @Input() noButton?: boolean = false;
  @Input() left_align?: boolean = false;
  @Input() titleLabel?: string;
  task = `${this.env.cloudFrontImgUrl}/private/compressed/lp/webp/how+to+1.webp`;

  public tasks = [
    {
      id: 244,
      title: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.FURNITURE_ASSEMBLY.TITLE',
      ),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.FURNITURE_ASSEMBLY.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/furntiture_assembly-min.png`,
    },
    {
      id: 245,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.PAINTING.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.PAINTING.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/painter-min.png`,
    },
    {
      id: 246,
      title: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.MOVING_ASSISTANCE.TITLE',
      ),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.MOVING_ASSISTANCE.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/mover-min.png`,
    },
    {
      id: 247,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.GARDENING.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.GARDENING.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/gardener-min.png`,
    },
    {
      id: 248,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.IT_SUPPORT.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.IT_SUPPORT.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/tech_support-min.png`,
    },
    {
      id: 249,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.ELECTRICIAN.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.ELECTRICIAN.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/electrician_lamp-min.png`,
    },
    {
      id: 250,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.CLEANING.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.CLEANING.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/cleaning-min.png`,
    },
    {
      id: 251,
      title: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.MOVING_ASSISTANCE_2.TITLE',
      ),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.MOVING_ASSISTANCE_2.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/movers_home-min.png`,
    },
    {
      id: 252,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.ELECTRICIAN_2.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.ELECTRICIAN_2.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/lamp_hanging-min.png`,
    },
    {
      id: 253,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.CATERING.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.CATERING.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/catering-min.png`,
    },
    {
      id: 254,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.PLUMBING.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.PLUMBING.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/plumber-min.png`,
    },
    {
      id: 255,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.CARPENTRY.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.CARPENTRY.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/carpenter-min.png`,
    },
    {
      id: 256,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.DOG_WALKING.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.DOG_WALKING.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/dog_walker-min.png`,
    },
    {
      id: 257,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.PHOTOGRAPHY.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.PHOTOGRAPHY.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/photographer-min.png`,
    },
    {
      id: 258,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.WEB_DESIGN.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.WEB_DESIGN.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/design-min.png`,
    },
    {
      id: 259,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.TUTORING.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.TUTORING.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/tutor-min.png`,
    },
    {
      id: 260,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.WINDOW_CLEANING.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.WINDOW_CLEANING.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/window_cleaning-min.png`,
    },
    {
      id: 261,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.LAWN_MOWING.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.LAWN_MOWING.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/lawn_mowing-min.png`,
    },
    {
      id: 262,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.GRAPHIC_DESIGN.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.GRAPHIC_DESIGN.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/digital_design-min.png`,
    },
    {
      id: 263,
      title: this.t.transform('PAGES.HOW_IT_WORKS.TASKS.HANDYMAN.TITLE'),
      description: this.t.transform(
        'PAGES.HOW_IT_WORKS.TASKS.HANDYMAN.DESCRIPTION',
      ),
      image: `${this.env.cloudFrontImgUrl}/private/lp/handyman-min.png`,
    },
  ];
  public steps = [
    { num: 1, key: 'PAGES.HOW_IT_WORKS.STEP_1', leftAlign: true },
    { num: 2, key: 'PAGES.HOW_IT_WORKS.STEP_2', leftAlign: false },
    { num: 3, key: 'PAGES.HOW_IT_WORKS.STEP_3', leftAlign: false },
  ];
  public taskPairs: any[][] = [];
  public isPaused: boolean = false;

  constructor(
    private dialog: MatDialog,
    private t: TranslatePipe,
    public externalService: ExternalService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit() {
    // Split tasks into two large chunks instead of pairs
    const halfLength = Math.ceil(this.tasks.length / 2);
    this.taskPairs = [
      this.tasks.slice(0, halfLength),
      this.tasks.slice(halfLength),
    ];
  }

  public openVideoDialog() {
    this.dialog.open(VideoDialogComponent, {
      disableClose: true,
      panelClass: 'full-screen-modal-mobile',
      width: '800px',
      maxWidth: 'unset',
      data: {
        title: this.t.transform('PAGES.HOW_IT_WORKS.HEADLINE'),
        vidChoice: 'howItWorks',
      },
    });
  }

  togglePause() {
    this.isPaused = !this.isPaused;
  }
}
